import { Button, Heading, Stack } from '@etg/wings';
import { variants } from '@eti/components';
import { MagnifyingGlass } from '@phosphor-icons/react';

interface NoResultsContentProps {
  buttonText?: string;
  dataTestId: string;
  description: string;
  onClick?: () => void;
  title: string;
}

const NoResultsContent = ({
  buttonText,
  dataTestId,
  description,
  onClick,
  title,
}: NoResultsContentProps) => {
  return (
    <>
      <MagnifyingGlass color="#4d4d4d" size={28} weight="thin" />
      <Stack align="center" spacing={8}>
        <Heading level={3}>{title}</Heading>
        {description}
      </Stack>
      {buttonText && (
        <Button data-testid={dataTestId} onClick={onClick} variant={variants.SECONDARY}>
          {buttonText}
        </Button>
      )}
    </>
  );
};

export default NoResultsContent;
